

import React, { useState, useEffect } from 'react';
import { FaCircle } from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './Shop.css';
// import CoolBeanz from '../assets/brik.png';
// import JIowef from '../assets/briksupport.jpg';
// import utilityCard from "../assets/utility.png";
// import knifeCard from "../assets/knife.png";
// import knifeCard1 from "../assets/knifeshiv.png";
// import brikCard from "../assets/brikcard.png";
// import brikCard1 from "../assets/brikkycard.png";
// import brikCard2 from "../assets/brikkycard1.png";
// import battert from "../assets/battery.png";
// import powerbank from "../assets/battery.png";
// import bottle from "../assets/bottles.png";
// import bottle1 from "../assets/bottles1.png";

// import brikwallet from "../assets/walletyuh.png";
// import brikwallet1 from "../assets/walletpic.png";
import brikwallet2 from "../assets/new-version/4.png";
import brikwallet3 from "../assets/new-version/5.png";
import brikwallet4 from "../assets/new-version/6.png";
import brikwallet5 from "../assets/new-version/7.png";
import brikwallet6 from "../assets/new-version/8.png";
import brikwallet7 from "../assets/new-version/9.png";
import brikwallet8 from "../assets/new-version/10.png";

import metalBasic from "../assets/newest-version/Full - nothing extended just basic.jpg";
import metalFull from "../assets/newest-version/Full Front - Everything extended.jpg";
import metalCards from "../assets/newest-version/Credit Cards Extended.jpg";
import metalId from "../assets/newest-version/ID Card Holder.jpg";
import metalTracking from "../assets/newest-version/Integrated Tracking Card.jpg";
import metalKeys from "../assets/newest-version/Keys Holder (1).jpg";
// import batterypack from "../assets/batterypack.png";
// import batterypack1 from "../assets/batterypack1.png";
// import utilityCard1 from "../assets/utility1.png";
// import hunting from "../assets/hunt4.png";
// import hunting1 from "../assets/hunt.png";


const products = [
  {
    id: 0,
    name: 'Metal Wallet',
    price: '$69.99',
    images: [metalBasic, metalFull, metalCards, metalId, metalTracking, metalKeys],
    link: '/metal-wallet',
  },
  {
    id: 1,
    name: 'Wallet (plastic)',
    price: '$39.99',
    images: [brikwallet2, brikwallet3, brikwallet4, brikwallet5, brikwallet6, brikwallet7, brikwallet8],
    link: '/wallet',
    notForSale: true,
  },
  // {
  //   id: 3,
  //   name: 'Brik Card',
  //   price: '$12.99',
  //   images: [brikCard, brikCard1, brikCard2],
  //   link: '/card',
  // },
  // {
  //   id: 4,
  //   name: 'Folding Knife',
  //   price: '$15.99',
  //   images: [knifeCard, knifeCard1],
  //   link: '/knife',
  // },
  // {
  //   id: 5,
  //   name: 'Power Bank',
  //   price: '$20.99',
  //   images: [batterypack, batterypack1],
  //   link: '/powerbank',
  // },
  // {
  //   id: 6,
  //   name: 'Hunting Card',
  //   price: '$15.99',
  //   images: [hunting, hunting1],
  //   link: '/hunting',
  // },
  // {
  //   id: 7,
  //   name: 'Utility Card',
  //   price: '$10.99',
  //   images: [utilityCard, utilityCard1],
  //   link: '/utility',
  // },
  // {
  //   id: 8,
  //   name: 'Bottle Opener',
  //   price: '$7.99',
  //   images: [bottle, bottle1],
  //   link: '/bottle',
  // },
];

const Shop = () => {
  const [activeImage, setActiveImage] = useState({});
  const [touchStartX, setTouchStartX] = useState({});
  const [touchEndX, setTouchEndX] = useState({});

  // Initialize the first image as active for each product
  useEffect(() => {
    const initialActiveImages = {};
    products.forEach((product) => {
      initialActiveImages[product.id] = 0;
    });
    setActiveImage(initialActiveImages);
  }, []);

  // Handle the start of a touch event for a given product
  const handleTouchStart = (e, productId) => {
    setTouchStartX((prev) => ({ ...prev, [productId]: e.targetTouches[0].clientX }));
  };

  // Update the touch end position as the user moves their finger
  const handleTouchMove = (e, productId) => {
    setTouchEndX((prev) => ({ ...prev, [productId]: e.targetTouches[0].clientX }));
  };

  // Determine the swipe direction when the touch event ends
  const handleTouchEnd = (productId, numImages) => {
    const start = touchStartX[productId];
    const end = touchEndX[productId];
    const threshold = 50; // Minimum swipe distance in px

    if (start && end) {
      const diff = start - end;
      if (diff > threshold) {
        // Swiped left, go to next image
        setActiveImage((prevState) => ({
          ...prevState,
          [productId]: (prevState[productId] + 1) % numImages,
        }));
      } else if (diff < -threshold) {
        // Swiped right, go to previous image
        setActiveImage((prevState) => ({
          ...prevState,
          [productId]: (prevState[productId] - 1 + numImages) % numImages,
        }));
      }
    }
    // Reset touch values for this product
    setTouchStartX((prev) => ({ ...prev, [productId]: null }));
    setTouchEndX((prev) => ({ ...prev, [productId]: null }));
  };

  const handleDotClick = (productId, index) => {
    setActiveImage((prevState) => ({
      ...prevState,
      [productId]: index,
    }));
  };

  return (
    <div className="shop-container20">
      <SEO
        title="Shop: The Metal Brik Wallet"
        description="Shop The Brik: the metal wallet at $69.99, a minimalist everyday carry that holds your cards, ID, cash, and keys."
        path="/shop"
        preloadModels={["/models/open.glb"]}
      />
      <Header />
      <main className="shop-main20">
        <h1 className="shop-title20">Shop The Brik</h1>
        <p
          style={{
            fontFamily: "'Futura', sans-serif",
            textAlign: "center",
            color: "#555",
            fontSize: "15px",
            lineHeight: 1.6,
            maxWidth: "620px",
            margin: "0 auto 28px",
            padding: "0 20px",
          }}
        >
          Everything The Brik makes, in one place. The Metal Brik wallet keeps
          your cards, ID, cash, keys, and a rechargeable tracking card together
          for $69.99, with free shipping. In stock, shipped from Ames, Iowa.
        </p>
        <div className="product-container20">
          <div className="shop-grid20">
            {products.map((product) => {
              const badge = product.preorder
                ? { text: 'Preorder', color: '#111' }
                : product.notForSale
                ? { text: 'No longer for sale', color: '#b71c1c' }
                : null;
              return (
              <div
                key={product.id}
                className="shop-card20"
                onClick={() => {
                  if (!product.comingSoon) window.location.href = product.link;
                }}
                role={product.comingSoon ? undefined : "link"}
                tabIndex={product.comingSoon ? undefined : 0}
                onKeyDown={(e) => {
                  if (!product.comingSoon && (e.key === "Enter" || e.key === " ")) {
                    window.location.href = product.link;
                  }
                }}
                style={
                  product.comingSoon
                    ? { opacity: 0.7, cursor: "default" }
                    : { cursor: "pointer" }
                }
              >
                {product.comingSoon ? (
                  <div style={{position: "relative"}}>
                    <img
                      src={product.images[activeImage[product.id] ?? 0]}
                      alt={product.name}
                      className="shop-image20"
                    />
                    <div style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      color: "white",
                      padding: "12px 24px",
                      borderRadius: "8px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      whiteSpace: "nowrap"
                    }}>
                      Coming Soon
                    </div>
                  </div>
                ) : (
                  <a href={product.link} className="product-link20" style={{position: "relative", display: "block"}}>
                    {product.preorder ? (
                      <div className="shop-image20" style={{ background: "#dcdcdc", display: "block", overflow: "hidden" }}>
                        <model-viewer
                          src="/models/open.glb"
                          alt={product.name}
                          auto-rotate=""
                          orientation="00deg 00deg 0deg"
                          camera-orbit="0deg 00deg 90%"
                          interaction-prompt="none"
                          disable-zoom=""
                          shadow-intensity="0.8"
                          exposure="1"
                          style={{ width: "100%", height: "100%", background: "#dcdcdc", display: "block", pointerEvents: "none" }}
                        />
                      </div>
                    ) : (
                      <img
                        loading="lazy"
                        src={product.images[activeImage[product.id] ?? 0]}
                        alt={product.name}
                        className="shop-image20"
                        style={
                          product.notForSale
                            ? { filter: "grayscale(1)", opacity: 0.55 }
                            : undefined
                        }
                        onTouchStart={(e) => handleTouchStart(e, product.id)}
                        onTouchMove={(e) => handleTouchMove(e, product.id)}
                        onTouchEnd={() => handleTouchEnd(product.id, product.images.length)}
                      />
                    )}
                    {badge && (
                      <span style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: badge.color,
                        color: "white",
                        padding: "10px 18px",
                        borderRadius: "8px",
                        fontSize: "15px",
                        fontWeight: "bold",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                        whiteSpace: "nowrap",
                      }}>
                        {badge.text}
                      </span>
                    )}
                  </a>
                )}

                {/* Image Navigation Dots */}
                {!product.comingSoon && !product.preorder && (
                  <div
                    className="image-dots-container20"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="image-dots20">
                      {product.images.map((_, index) => (
                        <FaCircle
                          key={index}
                          className={`dot20 ${activeImage[product.id] === index ? 'active-dot20' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDotClick(product.id, index);
                          }}
                        />
                      ))}
                    </div>
                  </div>
                )}
                {/* Spacer to match card heights when dots are absent (preorder) */}
                {!product.comingSoon && product.preorder && (
                  <div
                    className="image-dots-container20"
                    aria-hidden="true"
                    style={{ background: "transparent", border: "2px solid transparent", visibility: "hidden" }}
                  >
                    <div className="image-dots20">
                      <FaCircle className="dot20" />
                    </div>
                  </div>
                )}

                <div className="shop-card20-content">
                  <h3 className="shop-card20-title">{product.name}</h3>
                  <div className="shop-actions20">
                    <span className="product-price20">{product.price}</span>
                    {product.comingSoon ? (
                      <span className="shop-button20" style={{opacity: 0.5, cursor: "default"}}>
                        Shop
                      </span>
                    ) : (
                      <a href={product.link} className="shop-button20">
                        {product.preorder ? 'Preorder' : product.notForSale ? 'View' : 'Shop'}
                      </a>
                    )}
                  </div>
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Shop;

